import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  DELETE_MOTIVO_INIT,
  UPDATE_MOTIVO_INIT,
  CREATE_MOTIVO_INIT,
  LIST_MOTIVO_INIT
} from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { IMotivosStatusEmpresa } from 'src/integracoes/servicos/mongo-atlas/modelos/IMotivosStatusEmpresa';
import { atualizarMotivo, criarMotivo, deletarMotivo, listarMotivos } from 'src/integracoes/servicos/mongo-atlas/funcoes/motivos';
import { createMotivoSuccess, deleteMotivoSuccess, listMotivoSuccess, motivoErrorMsg, updateMotivoSuccess } from './actions';

interface FetchListaMotivoResult {
  isError: boolean;
  motivos: IMotivosStatusEmpresa[] | null;
  errorMessage: string | null;
}


/* ------------------Lista motivos---------------- */
export const fetchListarMotivos = async (): Promise<FetchListaMotivoResult> => {
  try {
    const { status, dados, mensagem } = await listarMotivos();

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        motivos: dados,
        errorMessage: null,
      };
    }

    return {
      isError: true,
      motivos: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarMotivos() {
  try {
    const { isError, motivos, errorMessage } = yield call(fetchListarMotivos);

    if (!isError) {
      yield put(listMotivoSuccess(motivos));
    } else {
      yield put(motivoErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    yield put(
      motivoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchListarMotivos() {
  yield takeEvery(LIST_MOTIVO_INIT, parseListarMotivos);
}

/* ------------------Criar motivo ---------------- */
export const fetchCriarMotivo = async (motivo: any) => {
  try {
    const { status, dados, mensagem } = await criarMotivo(motivo);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarMotivo({ payload }: { payload: any, type: any }) {
  const { motivo } = payload;
  try {
    const { isCreated, msg, data } = yield call(fetchCriarMotivo, motivo);
    if (isCreated) {
      yield put(createMotivoSuccess({ msg, isCreated, motivo: data }));
    } else {
      yield put(motivoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      motivoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarMotivo() {
  yield takeEvery(CREATE_MOTIVO_INIT, parseCriarMotivo);
}


/* ------------------Atualiza motivo ---------------- */
export const fetchAtualizarMotivo = async (id: string, motivo: any) => {
  try {
    const { status, dados, mensagem } = await atualizarMotivo(id, motivo);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarMotivo({ payload }: { payload: any; type: any }) {
  const { id, motivo } = payload;
  try {
    const { isUpdated, msg, data } = yield call(fetchAtualizarMotivo, id, motivo,);
    if (isUpdated) {
      yield put(updateMotivoSuccess({ msg, isUpdated, motivo: data }));
    } else {
      yield put(motivoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      motivoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarMotivo() {
  yield takeEvery(UPDATE_MOTIVO_INIT, parseAtualizarMotivo);
}


/* ------------------Deletar motivo ---------------- */
export const fetchDeletarMotivo = async (id: string) => {
  try {
    const { status, mensagem, dados } = await deletarMotivo(id);
    if (status) {
      return {
        isDeleted: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isDeleted: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarMotivo({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isDeleted, msg, data } = yield call(fetchDeletarMotivo, id);

    if (isDeleted) {
      yield put(deleteMotivoSuccess({ msg, isDeleted, motivo: data }));
    } else {
      yield put(motivoErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      motivoErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarMotivo() {
  yield takeEvery(DELETE_MOTIVO_INIT, parseDeletarMotivo);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarMotivos),
    fork(watchCriarMotivo),
    fork(watchAtualizarMotivo),
    fork(watchDeletarMotivo)
  ]);
}
